module.exports = __webpack_public_path__ + "static/media/heartReaction.dd144317.svg";